import Vue from 'vue';
import Router from 'vue-router';
import LoginComponent from './views/Login.vue';
import DashBoard from './views/DashBoard.vue';
import Documents from './views/Documents.vue';
import HtmlDocument from './views/HtmlDocument.vue';
import store from './main';

Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'app',
      component: DashBoard,
      meta: { requiresAuth: true},
    },
    {
      path: '/dashboard/',
      name: 'dashboard',
      component: DashBoard,
      meta: { requiresAuth: true},
    },
    {
      path: '/login/',
      name: 'login',
      component: LoginComponent,
    },
    {
      path: '/documents',
      name: 'documents',
      component: Documents,
      meta: { requiresAuth: true},
    },
    {
      path: '/document/:id',
      name: 'document',
      component: HtmlDocument,
      meta: { requiresAuth: true},
    },
    {
      path: '/notes',
      name: 'notes',
      component: () => import('./views/Notes.vue'),
      meta: { requiresAuth: true},
    },
    {
      path: '/staff',
      name: 'staff',
      component: () => import('./views/staff/Data.vue'),
      meta: { requiresAuth: true},
    },
    {
      path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import('./views/About.vue'),
      meta: { requiresAuth: true},
    },
  ],
});

// router.beforeEach((to, from, next) => {

//   if (to.matched.some((record) => record.meta.requiresAuth)) {
//     if (!store.getters.isAuthenticated) {
//       next({
//         path: '/login',
//         query: {
//           redirect: to.fullPath,
//         },
//       });
//     } else {
//       next();
//     }
//   } else {
//     next();
//   }
// });

export default router;
